import { useQueryGetAllUiPreferences } from "@apis:ui_preferences/ui_preferences";
import { useUser } from "@libs:react-query-auth";
import { useMemo } from "react";

type UserPreference = {
  botsStreamingEnabled?: boolean | null;
};

type BotPreference = {
  isStreaming?: boolean | null;
};

interface UseCheckBotStreamingProps {
  botId?: string | null;
}

export const useCheckBotStreaming = ({ botId }: UseCheckBotStreamingProps) => {
  const user = useUser().data;
  const userId = user?.id;

  const { data: uiPreferences, isLoading } = useQueryGetAllUiPreferences(
    true,
    userId,
    undefined,
    {
      enabled: !!userId,
    },
  );

  const isStreamingEnabled = useMemo(() => {
    if (!uiPreferences || !userId) return false;

    const userPreference = uiPreferences.find(
      (pref) => pref.userId === userId && !pref.botId,
    );
    const userStreamingEnabled = (userPreference?.preference as UserPreference)
      ?.botsStreamingEnabled;

    const botPreference = uiPreferences.find(
      (pref) => !!botId && pref.botId === botId && pref.userId === userId,
    );
    const botStreamingEnabled = (botPreference?.preference as BotPreference)
      ?.isStreaming;

    return userStreamingEnabled === true || botStreamingEnabled === true;
  }, [uiPreferences, userId, botId]);

  return {
    isStreamingEnabled,
    isLoading,
  };
};
